import React, { PropTypes } from 'react'

import './MobileNavBar.scss'

const MobileNavBar = (props) => {
  const {
    leftControl,
    children,
    rightControl
  } = props

  return (
    <div className='MobileNavBar'>
      {
        leftControl &&
        <div className='MobileNavBar-left'>
          {leftControl}
        </div>
      }
      <div className='MobileNavBar-center'>{children}</div>
      {
        rightControl &&
        <div className='MobileNavBar-right'>
          {rightControl}
        </div>
      }
    </div>
  )
}

MobileNavBar.displayName = 'MobileNavBar'
MobileNavBar.propTypes = {
  leftControl: PropTypes.element,
  children: PropTypes.node.isRequired,
  rightControl: PropTypes.element
}
MobileNavBar.defaultProps = {}

export default MobileNavBar



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/MobileNavBar/MobileNavBar.js